import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Project } from '@ops/shared-types';

@Component({
  selector: 'app-project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectCardComponent {
  @Input() project?: Project;
  @Input() isShowFiscalYear: boolean = false;
  @Output() projectSelected = new EventEmitter<string>();

  viewDetails(projectId: string) {
    this.projectSelected.emit(projectId);
  }
}
